import Link from "next/link";
import React from "react";
import FaqHubProductCard from "./FaqHubProductCard";
import { FAQ_SLUG } from "@/constastants/Constant";

export default function FaqHubRelatedProducts({ products }) {
  if (!products?.length) return null;

  return (
    <section className="mt-10">
      <h2 className="font-mukta text-[1.5rem] md:text-[1.75rem] font-semibold text-[#161616]">
        Related Products
      </h2>
      <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {products.map((p) => (
          <FaqHubProductCard key={p.id} product={p} />
        ))}
      </div>
      <div className="mt-8 flex justify-center">
        <Link
          href={`/${FAQ_SLUG}`}
          className="font-mukta text-[0.95rem] font-semibold text-[#ef4136] underline underline-offset-4 hover:no-underline"
        >
          View All Products
        </Link>
      </div>
    </section>
  );
}
